import React from "react";
import * as Yup from "yup";
import {
  Row,
  Col,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelector from "../multiSelector";
import { followupOnOptionsList } from "../../utils";

const formSchema = Yup.object().shape({
  name: Yup.string().required("Program name is required"),
  followupPeriod: Yup.number().required("Program period is required"),
  notifyOnMissedTasksAfter: Yup.number().required("Notification period is required"),
});

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;

  return (
    <div className="">
      <div className="basic-info">
        <div className="members-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
          <div className="info">
            <Row>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="text"
                    name="name"
                    id="programName"
                    maxLength={50}
                    placeholder="Enter program name"
                    className={`form-control ${
                      errors.name && touched.name && "is-invalid"
                    }`}
                  />
                  {errors.name && touched.name ? (
                    <div className="invalid-feedback">{`${errors.name}`}</div>
                  ) : null}
                  <Label for="name" className="">
                    Program Name
                  </Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="number"
                    name="followupPeriod"
                    id="followupPeriod"
                    placeholder="Enter program period (days)"
                    className={`form-control ${
                      errors.followupPeriod && touched.followupPeriod && "is-invalid"
                    }`}
                  />
                  {errors.followupPeriod && touched.followupPeriod ? (
                    <div className="invalid-feedback">{`${errors.followupPeriod}`}</div>
                  ) : null}
                  <Label for="followupPeriod" className="">
                    Program Period
                  </Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="number"
                    name="notifyOnMissedTasksAfter"
                    id="notifyOnMissedTasksAfter"
                    placeholder="Enter duration (hours)"
                    className={`form-control ${
                      errors.notifyOnMissedTasksAfter && 
                      touched.notifyOnMissedTasksAfter && 
                      "is-invalid"
                    }`}
                  />
                  {errors.notifyOnMissedTasksAfter && touched.notifyOnMissedTasksAfter ? (
                    <div className="invalid-feedback">{`${errors.notifyOnMissedTasksAfter}`}</div>
                  ) : null}
                  <Label for="notifyOnMissedTasksAfter" className="">
                    Notify on Missed Tasks after
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={12}>
                <FormGroup className="mb-md-0">
                  <Label for="followupOn" className="mb-2">
                    Follow-up On
                  </Label>
                    <MultiSelector
                      name="followupOn"
                      placeholder="Select Things To Followup On.."
                      data={followupOnOptionsList}
                      handleChange={setFieldValue}
                      selected={values.followupOn}
                    />
                  {errors.followupOn && touched.followupOn ? (
                    <div className="invalid-feedback">{`${errors.followupOn}`}</div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};